import axios from "axios";
import authHeader from '../../../authheader'

const VFREINSTATEMENTURL = process.env.REACT_APP_APIURL + "/api/FirmVfReinstatement";

const getViolation = (reinstatementId) => {
    return axios.get(`${VFREINSTATEMENTURL}/violation`, { headers: authHeader(), params: { reinstatementId } });
}
const postViolation = (data) => {
    return axios.post(`${VFREINSTATEMENTURL}/violation`, data, { headers: authHeader() });
}
export default {
    getViolation,
    postViolation
}